import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { repiActions, repiProductCategories } from '../../../../store/repiStore';
import HorizontalScrollControl from '../../../layoutItems/horizontalScrollControl';
import Paging from '../../../common/pagingComponent';
import { get } from 'lodash';
import { formatNumber } from '../../repiUtils';

class RepiContractDetail extends React.Component {
    static defaultProps = {
        pageLimit: 10,
        getDunningLevel: () => ""
    };

    state = {
        page: 1
    }

    get locale() { return get(this.props, "activeLanguage.code"); }
    get isPlusOrEnforcement() { return this.props.isPlus() || this.props.contract.productCategory === repiProductCategories.claimEnforcement; }
    get payments() {
        return (isNullOrUndefined(this.props.contract) || isNullOrUndefined(this.props.contract.payments))
            ? [] : this.props.contract.payments;
    }

    render() {
        const { contract } = this.props;

        if (isNullOrUndefined(contract))
            return null;

        const paymentColSpan = this.isPlusOrEnforcement ? 5 : 3;
        const contractColSpan = this.isPlusOrEnforcement ? (contract.productCategory === repiProductCategories.regularPayment ? 4 : 5) : 3;

        return (
            <div>
                <HorizontalScrollControl leftArrowMargin="0em">
                <table className="repi-data-correction-table">
                    <thead>
                        <tr>
                            <td className="no-background is-uppercase repi-right-border" colSpan={paymentColSpan}>
                                <Translate id="Repi.Report.PaymentHistory.PaymentsHeader" />
                            </td>
                            <td className="no-background is-uppercase bold" colSpan={contractColSpan}>
                                <Translate id="Repi.Report.PaymentHistory.ContractsHeader" />
                            </td>
                        </tr>
                        <tr>
                            <td><Translate id="Repi.Report.PaymentHistory.DueDate"/></td>
                            <td><Translate id="Repi.Report.PaymentHistory.PaymentDate"/></td>
                            {this.isPlusOrEnforcement && <>
                                <td className="right"><Translate id="Repi.Report.PaymentHistory.Payment.AmountTotal" /></td>
                                <td className="right"><Translate id="Repi.Report.PaymentHistory.Payment.AmountPaid"/></td>
                            </>}
                            <td className="right repi-right-border light"><Translate id="Repi.Report.PaymentHistory.Payment.AmountOpen"/></td>
                            {this.isPlusOrEnforcement && <>
                                <td className="right bold"><Translate id={`Repi.Report.PaymentHistory.Contract.TotalAmount.${contract.productCategory}`}/></td>
                                {contract.productCategory !== repiProductCategories.regularPayment && <td className="right bold">
                                    <Translate id={`Repi.Report.PaymentHistory.Contract.RemainingAmount.${contract.productCategory}`}/>
                                </td>}
                            </>}
                            <td className="right bold"><Translate id="Repi.Report.PaymentHistory.Contract.OverdueAmount"/></td>
                            <td className="bold" style={{ paddingLeft: "10px" }}><Translate id="Repi.Report.PaymentHistory.Status"/></td>
                            <td className="bold"><Translate id="Repi.Report.PaymentHistory.Contract.DataEndDate"/></td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.paginatePayments().map((payment, paymentIndex) => <tr key={paymentIndex}>
                            <td >{payment.dueDateFormatted}</td>
                            <td>{payment.paymentDateFormatted}</td>
                            {this.isPlusOrEnforcement && <>
                                <td className="right">{formatNumber(payment.amountTotal, this.locale)}</td>
                                <td className="right">{formatNumber(payment.amountPaid, this.locale)}</td>
                            </>}
                            <td className="right repi-right-border">{formatNumber(payment.amountOpen, this.locale)}</td>
                            {this.isPlusOrEnforcement && <>
                                <td className="right">{formatNumber(payment.totalAmount, this.locale)}</td>
                                {contract.productCategory !== repiProductCategories.regularPayment &&
                                    <td className="right">{formatNumber(payment.remainingAmount, this.locale)}</td>}
                            </>}
                            <td className="right">{formatNumber(payment.overdueAmount, this.locale)}</td>
                            <td style={{ paddingLeft: "10px", overflowWrap: "break-word" }}>{this.props.getDunningLevel(payment.dunningLevel)}</td>
                            <td>{payment.dataEndDateFormatted}</td>
                        </tr>)}
                    </tbody>
                </table>
                </HorizontalScrollControl>
                {this.renderPaging()}
            </div>
        );
    }

    paginatePayments = () => {
        if (this.payments.length <= this.props.pageLimit)
            return this.payments;

        const startIndex = (this.state.page - 1) * this.props.pageLimit;
        return this.payments.slice(startIndex, startIndex + this.props.pageLimit);
    }

    renderPaging = () => {
        const mod = this.payments.length % this.props.pageLimit;
        const totalPages = (Math.floor(this.payments.length / this.props.pageLimit) + (mod === 0 ? 0 : 1)).toFixed();
        if (totalPages < 2)
            return null;

        return (
            <div className="result-paging hide-on-mobile" style={{ marginTop: "0.75em" }}>
                <Paging
                    style={{ fontSize: "0.875em" }}
                    justify="center"
                    selectedPage={this.state.page}
                    totalPages={totalPages}
                    setPage={(page) => this.setState({ page: page })}
                />
            </div>
        );
    }
}

export default connect(
    state => state.repi,
    dispatch => bindActionCreators(repiActions, dispatch)
)(withLocalize(RepiContractDetail));